import React, { useState } from "react";
import "./FormFieldsStyle.css";
import { Select } from "antd";

const Dropdown = (props) => {
  const dataList = props.item && props.item.text_data;
  const [open, setOpen] = useState(false);

  const handleChange = (e, op) => {
    if (e) {
      props?.inputValue?.current?.removeAttribute("disabled");
    } else {
      props?.inputValue?.current?.setAttribute("disabled", true);
    }
    // localStorage.setItem("inputValue", JSON.stringify({ key1: e }));

    const commaSeparatedValues = e.join(", ");
    localStorage.setItem(
      "inputValue",
      JSON.stringify({ key1: commaSeparatedValues })
    );
  };

  const handleOpenChange = (open) => {
    setOpen(open);
  };

  const Options = dataList?.data?.map((item) => (
    <Select.Option key={item.value} value={item.value}>
      {item.name}
    </Select.Option>
  ));

  return (
    <div
      className="form-group action-tab"
      style={{ width: "90%", marginLeft: "7px" }}
    >
      <Select
        mode="multiple"
        placeholder="Please select"
        defaultValue={[]}
        onChange={(e, op) => handleChange(e, op)}
        open={open}
        onDropdownVisibleChange={handleOpenChange}
        style={{ width: "100%" }}
        dropdownClassName="custom-select"
        className="custom-select"
      >
        {Options}
      </Select>
      <span className="validate">&nbsp;</span>
    </div>
  );
};

export default Dropdown;
